module.exports = __webpack_public_path__ + "img/spain.57fb4b63.svg";